module.exports = __webpack_public_path__ + "static/img/bg-gogo.cf9a5aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/bg-gogo.svg
// module id = 1273
// module chunks = 1